import {apiCall} from "../../common/apiActionHandler";
import axios from "axios";


export const refreshVerificationStatus = (id, callback) => async (dispatch, getState) => {
    const config = {
            method: "GET",
            url: `/api/email_domains/${id}/refresh_status`
        };

    apiCall(`Refresh verification status`, config, async config => {
        const response = await axios.request(config);
        callback && callback(response);
    }, dispatch, getState, false);

};
